import { NodeStatus } from 'components';
import { usePerms } from 'contexts/PermsContext';
import { isBuoyDevice } from 'features/Integrations/features/ConnectedDevices/features/Buoy/utils/buoyDeviceUtils';
import { hasDevicePermissionFromDevice } from 'features/Integrations/features/ConnectedSystems/utils/devicePermissionUtils';
import {
  openStageSettings,
  openDeviceSettings,
  openUSGSSettings,
  setSelectedDeviceId,
} from 'features/Integrations/state/slices/deviceSlice';
import { setSelectedDevice } from 'features/Integrations/state/thunks';
import { DeviceIsSystemType } from 'features/Integrations/utils/deviceComparisionUtils';
import { FaCog } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

/**
 * @param {{devices: object[], setSelectedDevice: (index: number, id?: number), onOpenDevice: ()}}
 */
export default function DeviceRow({ onOpenDevice = () => {}, devices, widget = false }) {
  const perms = usePerms();
  const dispatch = useDispatch();

  const onSelectDevice = (deviceId) => {
    // Always select by device id to keep map, graph, and list in sync
    dispatch(setSelectedDevice({ index: -1, id: deviceId }));
    dispatch(setSelectedDeviceId(deviceId));
  };

  const onSettingsClick = (e, device) => {
    if (DeviceIsSystemType(device, 'Flood')) {
      e.stopPropagation();
      dispatch(openStageSettings(device.id));
    } else if (device.system_type === 'USGS') {
      e.stopPropagation();
      dispatch(openUSGSSettings(device.id));
    } else {
      e.stopPropagation();
      dispatch(openDeviceSettings({ id: device.id, deviceSettings: true }));
    }
  };

  const onRowClick = (device) => {
    onSelectDevice(device.id);

    // AWARE and USGS devices open datasheets
    if (
      device.system_type === 'USGS' ||
      DeviceIsSystemType(device, 'Flood') ||
      isBuoyDevice(device)
    ) {
      onOpenDevice(device.id);
      return;
    }

    if (!widget) {
      dispatch(openDeviceSettings({ id: device.id, deviceSettings: device }));
    } else {
      dispatch(openDeviceSettings(device.id));
    }
  };

  return (
    <div>
      {devices.map((device, index) => (
        <div
          key={device.id || index}
          className={`row mx-0 px-2 py-2 align-items-center border-bottom border-theme-strong bg-${
            index % 2 ? 'primary-shadow' : 'base'
          }`}
          style={{ cursor: 'pointer' }}
          onClick={() => onRowClick(device)}
        >
          <div
            className="col-12 col-lg-4 overflow-hidden text-truncate"
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              whiteSpace: 'normal',
              minWidth: 0,
            }}
          >
            <p className="m-0">
              <span className="d-inline d-lg-none">Device: </span>
              {`${device.static_id ? device.static_id + ' ' : ''}${device.alias || device.name}`}
            </p>
          </div>
          <div className="col-12 col-lg-3 text-break">
            <p className="m-0">
              {' '}
              <span className="d-inline d-lg-none">Node ID: </span>
              {device.node_id}
            </p>
          </div>

          <div className="col-10 col-lg-3 d-flex align-items-center ps-0 pe-0">
            <NodeStatus device={device} />
          </div>

          {hasDevicePermissionFromDevice(perms, device, 'createEdit') && (
            <div
              className="col-2 d-flex align-items-center"
              onClick={(e) => onSettingsClick(e, device)}
            >
              <FaCog size={25} />
            </div>
          )}

          {!hasDevicePermissionFromDevice(perms, device, 'createEdit') && <div className="col-2" />}
        </div>
      ))}
    </div>
  );
}
